import { Redirect, Route, RouteComponentProps, Switch } from 'react-router-dom'

import useTitle from 'common/use-title'
import IntegrationConfiguration from 'components/IntegrationConfiguration'
import NoPermissionsSplashPage from 'components/NoPermissionsSplashPage'
import Applicants from 'routes/document-batches/Applicants'
import DailyBatches from 'routes/document-batches/DailyBatches'

interface DocumentsRouteProps extends RouteComponentProps {
  canViewDocuments: boolean
}
const DocumentsRoute = ({ match, canViewDocuments }: DocumentsRouteProps) => {
  useTitle('Scoir - Documents')

  // Check user permissions to view documents
  if (!canViewDocuments) {
    return <NoPermissionsSplashPage />
  }

  return (
    <Switch>
      <Route
        exact
        path={`${match.path}/batches/daily`}
        render={() => <DailyBatches />}
      />
      <Route
        exact
        path={`${match.path}/batches/applicants`}
        render={() => <Applicants />}
      />
      <Route
        exact
        path={`${match.path}/integrations`}
        render={() => <IntegrationConfiguration />}
      />
      <Redirect
        exact
        from={match.path}
        to={`${match.path}/batches/daily`}
      />
    </Switch>
  )
}

export default DocumentsRoute
